import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { TokenService } from "../services/token.service";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { AlertService } from "../components/alert/alert.service";
import { LoaderService } from "../components/loader/loader.service";
import { Router } from "@angular/router";
import { ROUTES } from "../constants";

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    
    private currentUrl?: string

    constructor(
      private tokenService: TokenService,
      private loaderService: LoaderService,
      private alertService: AlertService,
      private router: Router
    ) {
      this.router.events.subscribe(event => {
        this.currentUrl = this.router.url
      })
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const authReq = req.clone({
          headers: new HttpHeaders({
            'Authorization': `Bearer ${this.tokenService.getToken()}`
          })
        });

        return next.handle(authReq)
          .pipe(
            catchError((error) => {

                this.loaderService.hide()
                
                let errorMessage = 'Unknown error!';
                if (error.error instanceof ErrorEvent) {
                    errorMessage = `Error: ${error.error.message}`;
                } else {
                    errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
                }
                
                // check for a 404 error response
                if (error instanceof HttpErrorResponse) {
                    if (error.error.description === 'Authentication error. Invalid credentials') {
                      console.error(error)
                      this.alertService.showAlert('error', 'Error de autenticación, puede que su sesión haya expirado. Por favor, recargue la pagina')
                      this.tokenService.removeToken();
                      //setTimeout(() => this.router.navigate([ROUTES.LOGIN]), 10000)
                    }
                }
                
                return throwError(error);
            })
          );
    }
}